<template>
  <div class="shop">
    <Title></Title>
    <!-- 全国加盟 -->
    <div class="shop_bg">
      <div class="inner" style="padding: 0;">
        <div class="shop_bg_tit">
          全国加盟进行中
        </div>
        <div class="shop_bg_name">
          让天下没有难做的生意
        </div>
        <div class="shop_btn">
          申请入驻
        </div>
      </div>
    </div>
    <!-- 我的客户 -->

    <div class="shop_box" >
      <div class="inner" style="padding: 0;">
        <Shoptit :tit="{name:'我们的客户',english:'Our customers'}"></Shoptit>
        <Shoplist></Shoplist>
        <Shoptit :tit="{name:'我们的客户',english:'Our customers'}"></Shoptit>
        <Shopitem></Shopitem>
        <Shoptit :tit="{name:'申请表单',english:'Application form'}"></Shoptit>
        <Shoparea></Shoparea>
      </div>
    </div>
  </div>
</template>

<script>
  import Title from "../../components/title.vue"
  import Shoptit from "./components/shoptit.vue"
  import Shoplist from "./components/shoplist.vue"
  import Shopitem from "./components/shopitem.vue"
  import Shoparea from "./components/shoparea.vue"
  export default {
    name: 'shop',
    components: {
      Title,
      Shoptit,
      Shoplist,
      Shopitem,
      Shoparea
    },
    methods: {
      Load(){
        console.log(1);
      }
    }
  }
</script>

<style lang="less" scoped>
  .inner {
    width: 1300px;
    margin: 0 auto;
  }

  .shop_bg {
    width: 100%;
    height: 320px;

    .inner {
      background: url(../../../src/assets/shop_bg.jpg) no-repeat 100% 100%;
      height: 320px;

      .shop_bg_tit {
        padding-top: 80px;
        font-weight: 400;
        font-size: 50px;
        line-height: 87px;
        color: #FFFFFF;
        text-align: center;
        margin-bottom: 22px;
      }

      .shop_bg_name {
        font-weight: 500;
        font-size: 20px;
        line-height: 34px;
        color: #FFFFFF;
        text-align: center;
        margin-bottom: 25px;
      }

      .shop_btn {
        width: 113px;
        height: 30px;
        background: #FF4444;
        border-radius: 4px;
        font-weight: 700;
        font-size: 14px;
        line-height: 30px;
        text-align: center;
        margin: 0 auto;
        color: #FFFFFF;
      }
    }
  }

  .shop_box {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/shop/shop.vue